







































































































import {Prop} from "vue-property-decorator";
import {InOut} from "vue-inout-prop-decorator"
import {Component, Vue} from '@/shared/component';
import {Form} from "@/shared/form";
import {PrixClient} from "@/models/PrixClient";

import LoopForm from "@/shared/form/LoopForm.vue";

import InputEnumSelect from '@/components/Input/EnumSelect.vue';
import InputDatePicker from './DatePicker.vue';
import InputLongueursVente from "@/components/Input/LongueursVente.vue";
import storeLongueursVente from "@/stores/modules/longueursVente";

@Component({
	components: {
		LoopForm,
		InputEnumSelect,
		InputLongueursVente,
		InputDatePicker,
	}
})
export default class InputPrixClientsList extends Vue {

	private valueLongueursVente = null;
	
	@InOut({ type: Array  , isVModel: true }) private value!: PrixClient[];

	public async mounted(): Promise<void> {
		await storeLongueursVente.dispatch('getAll');
		this.valueLongueursVente = storeLongueursVente.state.all.data
	}

	private get form(): Form {
		return Form.searchParentForm(this);
	}

	private get formName(): string {
		return Form.searchParentName(this);
	}
	
	private clearForm(): void {
		if (this.form) {
			this.form.clearErrors(this.formName);
		}
	}
	
	private add(): void {
		this.clearForm();
		this.value.push(new PrixClient());
		this.$emit('input', this.value);
	}
	
	private remove(index: number): void {
		this.value.splice(index, 1);
	}
}
